var _path, _path2, _path3, _circle, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 5V5C51.8324 7.3322 53.6678 9.16756 56 10V10V10C53.6678 10.8324 51.8324 12.6678 51 15V15V15C50.1676 12.6678 48.3322 10.8324 46 10V10V10C48.3322 9.16756 50.1676 7.3322 51 5V5Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0357 1V1C57.5411 2.41598 58.6555 3.53031 60.0714 4.03571V4.03571V4.03571C58.6555 4.54112 57.5411 5.65545 57.0357 7.07143V7.07143V7.07143C56.5303 5.65545 55.416 4.54112 54 4.03571V4.03571V4.03571C55.416 3.53031 56.5303 2.41598 57.0357 1V1Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4654 9.5V9.5C59.9708 10.916 61.0851 12.0303 62.5011 12.5357V12.5357V12.5357C61.0851 13.0411 59.9708 14.1555 59.4654 15.5714V15.5714V15.5714C58.96 14.1555 57.8457 13.0411 56.4297 12.5357V12.5357V12.5357C57.8457 12.0303 58.96 10.916 59.4654 9.5V9.5Z",
    fill: "#1A1B1D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4803_12264)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 19,
    fill: "#182A4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 47C43.4934 47 52 38.4934 52 28C52 17.5066 43.4934 9 33 9C22.5066 9 14 17.5066 14 28C14 38.4934 22.5066 47 33 47ZM30.4699 17.0751C27.4854 17.0751 25.0889 19.4712 25.0889 22.4556C25.0889 25.441 27.4853 27.8372 30.4699 27.8372C33.4546 27.8372 35.851 25.441 35.851 22.4556C35.851 19.4712 33.4545 17.0751 30.4699 17.0751ZM27.9551 29.7544C25.0587 29.7544 22.7107 32.1024 22.7107 34.9989C22.7107 36.4219 23.8643 37.5755 25.2873 37.5755H35.3597C36.7827 37.5755 37.9363 36.4219 37.9363 34.9989C37.9363 32.1024 35.5883 29.7544 32.6919 29.7544H27.9551ZM37.0869 25.7788C36.7637 26.2881 36.975 27.0109 37.5782 27.0109C40.311 27.0109 42.5051 24.817 42.5051 22.0835C42.5051 19.351 40.3109 17.1571 37.5782 17.1571C36.6769 17.1571 36.4914 18.2713 36.9951 19.0187C37.6573 20.0013 38.0429 21.1876 38.0429 22.4685C38.0429 23.6894 37.6928 24.8243 37.0869 25.7788ZM42.3823 36.9472C41.0912 36.9472 40.0445 35.9005 40.0445 34.6093V33.6183C40.0445 32.5596 39.6659 31.5804 39.0238 30.784C38.7018 30.3846 38.9627 29.5965 39.4757 29.5965C42.3721 29.5965 44.7201 31.8033 44.7201 34.5255V34.6093C44.7201 35.9005 43.6735 36.9472 42.3823 36.9472Z",
    fill: "url(#paint0_linear_4803_12264)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 47C43.4934 47 52 38.4934 52 28C52 17.5066 43.4934 9 33 9C22.5066 9 14 17.5066 14 28C14 38.4934 22.5066 47 33 47ZM30.4699 17.0751C27.4854 17.0751 25.0889 19.4712 25.0889 22.4556C25.0889 25.441 27.4853 27.8372 30.4699 27.8372C33.4546 27.8372 35.851 25.441 35.851 22.4556C35.851 19.4712 33.4545 17.0751 30.4699 17.0751ZM27.9551 29.7544C25.0587 29.7544 22.7107 32.1024 22.7107 34.9989C22.7107 36.4219 23.8643 37.5755 25.2873 37.5755H35.3597C36.7827 37.5755 37.9363 36.4219 37.9363 34.9989C37.9363 32.1024 35.5883 29.7544 32.6919 29.7544H27.9551ZM37.0869 25.7788C36.7637 26.2881 36.975 27.0109 37.5782 27.0109C40.311 27.0109 42.5051 24.817 42.5051 22.0835C42.5051 19.351 40.3109 17.1571 37.5782 17.1571C36.6769 17.1571 36.4914 18.2713 36.9951 19.0187C37.6573 20.0013 38.0429 21.1876 38.0429 22.4685C38.0429 23.6894 37.6928 24.8243 37.0869 25.7788ZM42.3823 36.9472C41.0912 36.9472 40.0445 35.9005 40.0445 34.6093V33.6183C40.0445 32.5596 39.6659 31.5804 39.0238 30.784C38.7018 30.3846 38.9627 29.5965 39.4757 29.5965C42.3721 29.5965 44.7201 31.8033 44.7201 34.5255V34.6093C44.7201 35.9005 43.6735 36.9472 42.3823 36.9472Z",
    fill: "url(#paint1_linear_4803_12264)",
    fillOpacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4803_12264)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4803_12264)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55.5C52 52.4624 43.4934 50 33 50C22.5066 50 14 52.4624 14 55.5C14 58.5376 22.5066 61 33 61C43.4934 61 52 58.5376 52 55.5Z",
    fill: "url(#paint2_linear_4803_12264)",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4803_12264",
    x: 8,
    y: 44,
    width: 50,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_4803_12264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4803_12264",
    x1: 46.4583,
    y1: 14.5417,
    x2: 19.5417,
    y2: 41.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4803_12264",
    x1: 46.4583,
    y1: 14.5417,
    x2: 19.5417,
    y2: 41.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4803_12264",
    x1: 46.4583,
    y1: 59.3958,
    x2: 42.2961,
    y2: 45.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB783"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4803_12264"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4803_12264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 11,
    rx: 5.5,
    transform: "matrix(1 0 0 -1 14 61)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityLimitation);
export default __webpack_public_path__ + "static/media/community-limitation.a7ca01bb58adfdd0c30b5bdb102ac588.svg";
export { ForwardRef as ReactComponent };